import * as S from './Tabs.styles'

interface TabComponentProps {
  title: string
  active: boolean
  isFresh: boolean
  onClick: () => any
}

export const TabComponent = ({
  isFresh, active, onClick, title,
}: TabComponentProps) => {
  if (isFresh) {
    return (
      <S.FreshTab active={active} onClick={onClick}>
        {title}
      </S.FreshTab>
    )
  }

  return (
    <S.Tab active={active} onClick={onClick}>
      {title}
    </S.Tab>
  )
}
